import React from 'react';
import { Redirect } from 'react-router-dom';
import PimID from '../containers/PimID';
import { localStorageGet } from '../utils/localStorageHelper';

export default function PimIdRoute() {
  const { partner } = localStorageGet('partner');
  return partner === 'optum' ? <PimID /> : <Redirect exact to='email' />;
}
